module.exports = __webpack_public_path__ + "img/logomark-white.0b81c5e6.svg";